import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getSettings } from "@/lib/api";

const SettingsContext = createContext(null);
const DEFAULTS = { theme: "rarecandy-light", logo_url: "", hero_image_url: "", hero_bg_url: "" };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const applyTheme = useCallback((theme) => {
    document.documentElement.setAttribute("data-theme", theme || "rarecandy-light");
  }, []);

  const refresh = useCallback(async () => {
    try {
      const data = await getSettings();
      setSettings(data);
      applyTheme(data.theme);
    } catch {
      applyTheme("rarecandy-light");
    }
  }, [applyTheme]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refresh, applyTheme }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULTS, refresh: () => {}, applyTheme: () => {} };
